<div *ngIf="place">
  {{ place.position.latitude | number: "1.2-6" }} /
  {{ place.position.longitude | number: "1.2-6" }}
</div>
<div *ngIf="!place">&nbsp;</div>
